export default function getInitialItemsOrDefault<T>(
  collection: T[],
  numberOfItemsToReturn: number,
  defaultItems: T[]
) {
  return collection.length > 0
    ? collection.slice(0, numberOfItemsToReturn)
    : defaultItems;
}
